import { makeStyles } from '@material-ui/styles';

import { grey750 } from '../../ThemeProvider';

export const useStyles = makeStyles(({ palette }) => ({
    paper: {
        marginBottom: '1px',
        marginRight: '8px',
        display: 'flex',
        flex: 0,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '42px',
        minWidth: '64px',
        backgroundColor: palette.type === 'light' ? palette.grey['300'] : grey750,
        border: `1px solid ${palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : palette.borderColor}`,

        '-webkit-user-select': 'none',
        '-moz-user-select': 'none',
        '-ms-user-select': 'none',
        userSelect: 'none',
    },
}));
